import { addMethod, object } from '@calendly/form/validation';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import ImageUpload from 'components/core/image_upload';
const imageUploadButtonCss = "i1bttn5f";
const ImageUploadButton = forwardRef((props, ref) => {
  const as = 'label';
  return <Button ref={ref} {...props} as={as} className={classNames(imageUploadButtonCss, props.className)} />;
});
export default ({
  children,
  onFileSelect,
  onFileError,
  cropShape,
  cropRatio,
  validate,
  ...props
}) => <ImageUploadButton {...props}>
    {children}
    <ImageUpload onFileSelect={onFileSelect} onFileError={onFileError} cropShape={cropShape} cropRatio={cropRatio} validate={validate} />
  </ImageUploadButton>;
const defaultValidFileExtensions = ['jpg', 'gif', 'jpeg', 'png'];
const isValidFileType = (fileName, extensions) => fileName && extensions.indexOf(fileName.split('.').pop()) > -1;
addMethod(object, 'validImageUploadField', function method(validExtensionList = null, message = null) {
  return this.test('validImageUploadField', null, (imageField, parentCtx) => {
    if (!imageField) {
      return object;
    }
    if (imageField.file && imageField.file instanceof File) {
      const {
        file
      } = imageField;
      const errorMessage = I18n.t('errors.messages.extension_allowlist_error', {
        extension: file?.name?.split('.')?.pop(),
        allowed_types: (validExtensionList || defaultValidFileExtensions).join(', ')
      });
      if (file !== null && !isValidFileType(file.name.toLowerCase(), validExtensionList || defaultValidFileExtensions)) {
        return parentCtx.createError({
          path: parentCtx.path,
          message: message || errorMessage
        });
      }
      return true;
    }
    if (imageField.url && (imageField.url instanceof String || imageField.url === null)) {
      return true;
    }
    return false;
  });
});

require("./image_upload_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./image_upload_button.js");